/*=========================================================================================
  File Name: moduleSpaceState.js
  Description: Space Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ActiveProjectInfo: {
      title:'test',
      url:'/test',
      id:0
  },
  ActiveProjectLevel: 0,
  projects: [],
  workspaceList: [], // workspace list와는 다르게 project를 포함하고 있는 workspace list
  workspaceProjects: [],
  selectWorkspaceInfo :{},
  selectProjectInfo :{},

}
